import { Box, Card, NavList, RadioIcon } from '@deckee/deck-hand';
import React, { useEffect, useState } from 'react';
import {
  getFeatures,
  getFeaturesConfiguration,
  toggleFeature,
} from '../../../../../services/feature';
import { definitions, emit } from '../../../../../services/message-broker';
import { ROUTE_SETTINGS } from '../../../../../services/route/route-names';
import { transitionToNextRoute } from '../../../../../services/route/route-navigation';
import { useAppDispatch } from '../../../../../services/store';
import { setSettingsFeatures } from '../../../../../services/store/modules/app-controls';
import BasicDrawerLayout from '../../../../layouts/BasicDrawerLayout/BasicDrawerLayout';
import { LayoutBody } from '../../../../layouts/components/LayoutBody/LayoutBody';
import IconWithTextLockup from '../../../../lockups/IconWithTextLockup/IconWithTextLockup';
import CheckSwitch from '../../../../shared/_deprecated/components/CheckSwitch/CheckSwitch';
import Text from '../../../../shared/_deprecated/elements/Text/Text';

const SettingsFeaturesPage = () => {
  const dispatch = useAppDispatch();

  const [count, setCount] = useState(0);
  const [showStable, setShowStable] = useState(false);

  useEffect(() => {
    dispatch(setSettingsFeatures({}));
  }, [dispatch]);

  const features = getFeatures();
  const featuresConfiguration = getFeaturesConfiguration();

  const handleClick = (feature) => {
    toggleFeature(feature);
    emit(definitions.settings.featureChange, { feature });

    // Because features are being changed by using the emit function, it was causing this component not to re-render.
    // In the class based implementation, it was using the forceUpdate function to re-render the component. So until
    // the emit() is swapped out (likely for an action dispatch), this is a workaround to re-render the component.
    setCount(count + 1);
  };

  return (
    <BasicDrawerLayout
      heading="Test features"
      onBack={() =>
        transitionToNextRoute(ROUTE_SETTINGS, {
          /* parameters */
        })
      }
    >
      <LayoutBody>
        <NavList>
          <NavList.Item onClick={() => setShowStable(!showStable)}>
            <IconWithTextLockup
              heading="Include stable features"
              image={<RadioIcon color="#BABABA" size={32} />}
            />
            <Box display="flex" ml="auto">
              <CheckSwitch isActive={showStable} />
            </Box>
          </NavList.Item>
        </NavList>
        <Card>
          <Card.Heading>
            <Box>Features</Box>
          </Card.Heading>

          <Card.Body>
            <NavList>
              {features ? (
                Object.keys(features)
                  .filter((feature) => {
                    if (showStable) {
                      return true;
                    }
                    return featuresConfiguration[feature]?.stage !== 'stable';
                  })
                  .map(
                    (feature) =>
                      featuresConfiguration[feature] && (
                        <NavList.Item
                          key={`map-option-feature_${feature}`}
                          edge
                          grouped
                          onClick={() => handleClick(feature)}
                        >
                          <IconWithTextLockup
                            heading={feature}
                            image={<RadioIcon color="#BABABA" size={32} />}
                            description={
                              <>
                                <Text type="alternate-light" size="-2" italic>
                                  {featuresConfiguration[feature].stage}{' '}
                                  {featuresConfiguration[feature].description}
                                </Text>
                              </>
                            }
                          />

                          <Box display="flex" ml="auto">
                            <CheckSwitch isActive={features[feature]} />
                          </Box>
                        </NavList.Item>
                      ),
                  )
              ) : (
                <Text type="alternate-light" size="-1" align="center" italic>
                  No features available
                </Text>
              )}
            </NavList>
          </Card.Body>
        </Card>
      </LayoutBody>
    </BasicDrawerLayout>
  );
};

export default SettingsFeaturesPage;
